import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaUserFriends, FaTasks, FaListAlt, FaChartLine } from 'react-icons/fa';
import { API_BASE_URL } from '../config';
import { fetchWithAuth } from '../utils/fetchWithAuth';
import './Home.css';

function Home() {
    const [headerColor, setHeaderColor] = useState('#ff0000');
    const [fontColor, setFontColor] = useState('light');
    const [logoUrl, setLogoUrl] = useState('');

    useEffect(() => {
        const loadSettings = async () => {
            try {
                const response = await fetchWithAuth(`${API_BASE_URL}/get_settings`);
                
                if (!response.ok) {
                    console.error(`HTTP error! Status: ${response.status}`);
                    return;
                }
                
                const settings = await response.json();
                settings.forEach(setting => {
                    if (setting.SettingName === 'headerColor') setHeaderColor(setting.SettingValue);
                    if (setting.SettingName === 'fontColor') setFontColor(setting.SettingValue);
                    if (setting.SettingName === 'logoUrl') setLogoUrl(setting.SettingValue);
                });
                
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        loadSettings();
    }, []);

    const navigationItems = [
        {
            title: "Service Recipients",
            description: "Manage service recipients and their information",
            icon: <FaUserFriends />,
            link: "/care-recipients"
        },
        {
            title: "Activities",
            description: "View and manage service activities",
            icon: <FaTasks />,
            link: "/activities"
        },
        {
            title: "Price Lists",
            description: "Manage pricing and service items",
            icon: <FaListAlt />,
            link: "/priceList"
        },
        {
            title: "Staff Demand Report",
            description: "Generate and view staff demand reports",
            icon: <FaChartLine />,
            link: "/staff-demand-report"
        }
    ];

    return (
        <div className="home-container">
            <div className="home-header">
                <h1>Welcome to Wandawazi Flow Dashboard</h1>
                <p>Manage your service plans efficiently</p>
            </div>

            <div className="navigation-grid">
                {navigationItems.map((item, index) => (
                    <Link key={index} to={item.link} className="navigation-card">
                        <div className="card-icon">
                            {item.icon}
                        </div>
                        <div className="card-content">
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default Home;
